export const adListingAutoLoad = {
    requestUrl: null,
    formElementId: null,
    elementToListData: null,
    isAjaxResponseCompleted: false,
    pageFold: 0,
    init(options) {
        this.requestUrl = options.requestUrl ? options.requestUrl : this.requestUrl;
        this.formElementId = options.formElementId ? options.formElementId : this.formElementId;
        this.elementToListData = options.elementToListData;
        try {
            $(window).scroll(function () {
                let $loadMore = $('.loadMore');
                let nextPage = parseInt($loadMore.data('rel'), 10);
                if (nextPage > 0) {
                    if (!adListingAutoLoad.belowFold($loadMore, window) && !adListingAutoLoad.isAjaxResponseCompleted) {
                        adListingAutoLoad.getAdData(nextPage);
                    }
                }
            });
        } catch (_e) {
            // ignore scroll init errors
        }
    },
    belowFold(element, container) {
        if (container === undefined || container === window) {
            this.pageFold = $(window).height() + $(window).scrollTop();
        } else {
            this.pageFold = $(container).offset().top + $(container).height();
        }
        return this.pageFold <= $(element).offset().top + 25;
    },
    getAdData(nextPage) {
        this.isAjaxResponseCompleted = true;
        let params = `${$(`#${this.formElementId}`).find('input, select').serialize()}&page=${nextPage}`;

        this.showLoader();
        $.ajax({
            type: 'GET',
            url: this.requestUrl,
            data: params,
            success(data) {
                adListingAutoLoad.isAjaxResponseCompleted = false;
                $(`#${adListingAutoLoad.elementToListData}`).append(data);
                $(`#loadMore${nextPage}`).remove();
                adListingAutoLoad.hideLoader();
                adListingAutoLoad.showHideContentInAdList();
            },
        });
    },
    showHideContentInAdList() {
        $('.checkLineHeight').each(function () {
            if ($(this).innerHeight() > parseInt($(this).data('lineheight'), 10)) {
                $(this).parent().next().show();
            } else {
                $(this).closest('.list-card-sds__info').addClass('no-multiple-lines');
            }
        });
    },
    showLoader() {
        $('.global-loader-img-big').show();
    },
    hideLoader() {
        $('.global-loader-img-big').hide();
    },
};

// show context as per space available
adListingAutoLoad.showHideContentInAdList();
